export default __webpack_public_path__ + "static/AbuDhabi-2e23131956135331d1388acf7c76c0df.jpg";